import { createPortal } from 'react-dom';
import Button from '../Button/Button';
import styles from './ConfirmModal.module.css';

function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    isLoading = false,
    variant = 'danger' // 'danger' or 'primary'
}) {
    if (!isOpen) return null;

    return createPortal(
        <div className={styles.overlay}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.title}>{title}</h2>
                    <button
                        className={styles.closeButton}
                        onClick={onClose}
                        disabled={isLoading}
                        type="button"
                    >
                        ×
                    </button>
                </div>
                <div className={styles.content}>
                    <p className={styles.message}>{message}</p>
                </div>
                <div className={styles.buttons}>
                    <Button
                        variant="secondary"
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={variant === 'danger' ? 'danger' : 'primary'}
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </div>
        , document.body);
}

export default ConfirmModal;
